
import { Routes } from '@angular/router';




export const aiModuleroutes: Routes = [{
    path: '', loadComponent: () => import('./base-ai-component/base-ai-component.component').then(m => m.BaseAiComponentComponent),
    children: [
        {
            path: 'aiLanding', // Child route (parent/a)
            loadComponent: () => import('./ai-landing-page/ai-landing-page.component').then(m => m.AiLandingPageComponent)
        },
        {
            path: 'textHelp',
            loadComponent: () => import('./help-text/help-text.component').then(m => m.HelpTextComponent)
        },
        {
            path: 'videoHelp',
            loadComponent: () => import('./video-help/video-help.component').then(m => m.VideoHelpComponent)
        },
        {
            path: 'aiChatArea',
            loadComponent: () => import('./ai-chat-area/ai-chat-area.component').then(m => m.AiChatAreaComponent)
        }
    ]

},];
